class SwiperImageTabs extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.tabs = this.querySelectorAll('.swiper-image-tabs__tab');
        this.swiperContainer = this.querySelector('.swiper-image-tabs__list');
    }

    connectedCallback() {
        this.initSwiper();
        this.addTabListeners();
    }

    initSwiper() {
        this.swiper = new Swiper(this.swiperContainer, {
            spaceBetween: 30,
            autoHeight: true,
            on: {
                slideChange: () => {
                    this.updateActiveTab();
                },
            },
        });
    }

    addTabListeners() {
        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                this.swiper.slideTo(index);
            });
        });
    }

    updateActiveTab() {
        this.tabs.forEach((tab, index) => {
            if (index === this.swiper.activeIndex) {
                tab.classList.add('active');
            } else {
                tab.classList.remove('active');
            }
        });
    }
}

customElements.define('swiper-image-tabs', SwiperImageTabs);
